<div class="hb-container hb-container--width-lg">
  <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Om statistikkbanken</h1>

  <div class="hb-tekstgruppe hb-tekstgruppe--optimal-linjelengde">
    <p>
      Statistikkbanken uvikles og vedlikeholdes av
      <a href="https://husbanken.no/om-husbanken/" target="_blank"
        >Husbanken
        <hb-icon iconId="expand-6" size="Size100"></hb-icon>
      </a>
    </p>
    <p>Her finner du statistikk fra Husbanken som viser søknader, tilsagn og utbetalinger på boligpolitiske virkemidler. </p>
    <p>Har du spørsmål kan du sende en henvendelse til <a href="mailto:statistikkgruppa@husbanken.no">statistikkgruppa&#64;husbanken.no</a></p>

    <h2 class="hb-h2">Om Husbankens data</h2>
    <h3>Anonymisering av data</h3>
    <p>
      På grunn av personvernhensyn har ikke Husbanken, for noen virkemidler, mulighet til å vise detaljert statistikk. Dette gjelder spesielt bostøtte og startlån. Dersom det ved
      hjelp av filtreringen kan fremkomme opplysninger der det er færre enn 4 observasjoner, så vil denne informasjonen ikke vises.
    </p>
    @if (kpi) {
      <p class="hb-text--sm">{{ kpi.header }}: {{ kpi.value.qText }}</p>
    }
  </div>
</div>
